import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceBase } from './service.base';
import { SelectItem } from 'primeng/api';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class GalleriesService extends ServiceBase {
  public api = '/gallery';

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
    console.log('GalleriesService initialized');
  }

  public fetch(): Observable<GalleryItems[]> {
    console.log('Fetching all galleries');
    const httpOptions = this.RequestHeaders();
    const method = '/fetch';
    const url = `${environment.BASE_API_PATH}${this.api}${method}`;
    return this.http.get<GalleryItems[]>(url, httpOptions);
  }

  public fetchDropdownData(): Observable<SelectItem[]> {
    console.log('Fetching dropdown data');
    const httpOptions = this.RequestHeaders();
    const method = '/dropdown-data';
    const url = `${environment.BASE_API_PATH}${this.api}${method}`;
    return this.http.get<SelectItem[]>(url, httpOptions);
  }

  public fetchById(galleryId: string): Observable<GalleryItems> {
    console.log(`Fetching gallery by ID: ${galleryId}`);
    const httpOptions = this.RequestHeaders();
    const method = `/${galleryId}`;
    const url = `${environment.BASE_API_PATH}${this.api}${method}`;
    return this.http.get<GalleryItems>(url, httpOptions);
  }

  public saveGallery(gallery: GalleryItems): Observable<ResponseObject> {
    console.log('Saving gallery:', gallery);
    const httpOptions = this.RequestHeaders();
    const method = '/save';
    const url = `${environment.BASE_API_PATH}${this.api}${method}`;
    return this.http.post<ResponseObject>(url, gallery, httpOptions);
  }

  public saveGalleryAddress(galleryId: string | null = null, galleryAddress: GalleryAddress): Observable<ResponseObject> {
    console.log(`Saving gallery address for galleryId: ${galleryId}`, galleryAddress);
    const httpOptions = this.RequestHeaders();
    const method = '/save/' + galleryId;
    const url = `${environment.BASE_API_PATH}${this.api}${method}`;
    return this.http.post<ResponseObject>(url, galleryAddress, httpOptions);
  }

  public deleteGallery(galleryId: string): Observable<ResponseObject> {
    console.log(`Deleting gallery with ID: ${galleryId}`);
    const httpOptions = this.RequestHeaders();
    const method = '/delete/';
    const url = `${environment.BASE_API_PATH}${this.api}${method}${galleryId}`;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

  public deleteAddress(addressId: any): Observable<ResponseObject> {
    console.log(`Deleting address with ID: ${addressId}`);
    const httpOptions = this.RequestHeaders();
    const method = '/deleteAddress/';
    const url = `${environment.BASE_API_PATH}${this.api}${method}${addressId}`;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }


  
 saveGalleryTermsDocuments(termsData: GalleryTermsData): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/terms`;
    return this.http.put<ResponseObject>(url, termsData, httpOptions);
  }

 attachGalleryDocument(documentData: AttachDocumentRequest): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/attch-document`;
    return this.http.post<ResponseObject>(url, documentData, httpOptions);
  }

  // Updated delete method to match the new API endpoint
  deleteGalleryDocument(documentId: string): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/document/${documentId}`;
    return this.http.delete<ResponseObject>(url, httpOptions);
  }

public saveGalleryArtTypes(artTypeIds: string[]): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/artTypes'; 
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url, artTypeIds, httpOptions); 
  }
 public getGalleryArtTypes(): Observable<any> {
    const httpOptions = this.RequestHeaders();
    const method: string = '/artTypes';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<any>(url, httpOptions);
  }

}

export enum GalleryDocumentSectionEnum {
  PaymentTerms = 1,
  ReturnPolicy = 2,
  TermsConditions = 3
}
export interface AttachDocumentRequest {
  section: GalleryDocumentSectionEnum;
  documentName: string;
  documentUrl: string;
}

export interface GalleryTermsData {
  paymentTerms: string;
  returnPolicy: string;
  termsConditions: string;
}

// Interface for gallery terms history DTO
export interface GalleryTermsHistroyDTO {
  Id: string;
  GalleryId: string;
  PaymentTerms: string;
  ReturnPolicy: string;
  TermsConditions: string;
  Version: number;
  CreatedDate: string | null;
  GalleryDocumentDTOs: GalleryDocumentDTO[];
}

// Interface for gallery document DTO (from API response)
export interface GalleryDocumentDTO {
  Id: string;
  Section: GalleryDocumentSectionEnum;
  DocumentName: string;
  DocumentUrl: string;
  UploadedAt?: string;
}
  export class GalleryItems {
    Id?: string;
    Name?: string;
    FirstName!: string;
    UserName!: string;   // REQUIRED
    GalleryImgUrl?: string;
    GalleryType?: string;
    Department?: string;
    Email!: string;
    PhoneNumber?: string | null;
    Fax?: string;
    Website?: string;
    FacebookLink?: string;
    InstagramLink?: string;
    LinkedinLink?: string;
    CommissionPercentage?: number;
    SalesTaxPercentage?: number;
    GallerySaleType?: string;
    Terms?: string;
    ABN?: string;
    AddGST?: boolean;
    GstId?: string;
    LastName?: string;
    Password?: string;
    BusinessName?: string;
    ConfirmPassword?: string;
    Country?: string;
    State?: string;
    City?: string;
    Zip?: string;
    Address1?: string;
    Address2?: string;
    PaymentTerms?: string;
    ReturnPolicy?: string;
    TermsConditions?: string;
    SubscriptionRuleSetId?: string;
    CurrencyCode?: string;
    GalleryAddresses: GalleryAddress[] = [];
    ProBySource?: string;
    UserDocumentDTOs?: UserDocumentDTOs[];

  // 🆕 New fields from latest API response
  GalleryArtTypesDTOs?: GalleryArtTypesDTOs[]; 
  TermsConditionsVersion?: number; 
  CreatedDate?: string; 
  GeneralDetails?: string | null; 
  DeliveryInstructions?: string | null; 
  IsPro?: boolean; 
  ProByPlatformDate?: string | null; 
  UnProByPlatformDate?: string | null; 
  PrimaryProductImageUrl?: string | null; 
  AboutMe?: string | null; 
  EstablishDate?: Date; 
GalleryTermsHistroyDTO?: GalleryTermsHistroyDTO; 

  }
  export interface ArtTypeDto {
  Id: string;
  Name: string;
  Description: string | null;
  IsActive: boolean;
}

export interface GalleryArtTypesDTOs {
  Id: string;
  GalleryId: string;
  ArtTypeId: string;
  ArtTypeDto: ArtTypeDto;
}

export class GalleryAddress {
  Id?: string;
  AddressType?: string;
  Address1?: string;
  Address2?: string;
  SuburbTown?: string;
  PostalCode?: string;
  State?: string;
  Country?: string;
  City?: string;
}

export interface UserDocumentDTOs {
  Id?: string;
  DocumentName: string;
  FilePath: string;
  UploadedAt: Date;
  DocumentType: string;
  UserId: string;
  Section?: GalleryDocumentSectionEnum;

}
export interface GalleryTerms {
  galleryId: string;
  paymentTerms: string;
  returnPolicy: string;
  termsConditions: string;
  termsConditionsVersion: number;
  userDocumentDTO: {
    id: string;
    userId: string;
    documentName: string;
    filePath: string;
    uploadedAt: string;
    documentType: string;
  }[];
}



export class ResponseObject {
  Success!: boolean;
  ResponseMessage!: string;
  ResponseData: any;
  Errors: string[] = [];
}